<div>
  <div class="card">
    <div class="card-body ">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="anno" class="control-label col-form-label">Anno</label>
            <input id="anno" [(ngModel)]="filtri.anno" class="form-control" type="number" step="1">
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label col-form-label">Stato</label>
            <ng-multiselect-dropdown [settings]="statodropdownSettings" [placeholder]="'Seleziona'" [data]="stati" [(ngModel)]="filtri.statiSelezionati" (ngModelChange)="refreshTable()">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="control-label col-form-label">Tipo cliente</label>
            <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Seleziona'" [data]="TipiCliente" [(ngModel)]="filtri.tipiSelezionati" (ngModelChange)="refreshTable()">
            </ng-multiselect-dropdown>
          </div>
        </div>
        <div class="col-md-1">
          <div class="form-group">
            <label for="anno" class="control-label col-form-label">Clienti</label>
            <input  [(ngModel)]="chkClienti" class="form-control" (ngModelChange)="ChangeListType('C')" type="checkbox" step="1">
          </div>
        </div>
        <div class="col-md-1">
          <div class="form-group">
            <label for="anno" class="control-label col-form-label">Tipi Clienti</label>
            <input  [(ngModel)]="chktipi" class="form-control" (ngModelChange)="ChangeListType('T')" type="checkbox" step="1">
          </div>
        </div>
        <div class="col-lg-3  ">
          <button  type="button" class="btn btn-info rounded-pill "  (click)='refreshTable()'>
            <i class="fas fa-search font-14 mr-1 text-white"></i>
            <span class="ml-1 text-white font-weight-bold" >Cerca</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table bg-white table-hover align-middle mb-0 ">
      <thead>
      <tr>
        <th scope="col">Cliente</th>
        <th scope="col">Gennaio</th>
        <th scope="col">Febbriaio</th>
        <th scope="col">Marzo</th>
        <th scope="col">Aprile</th>
        <th scope="col">Maggio</th>
        <th scope="col">Giugno</th>
        <th scope="col">Luglio</th>
        <th scope="col">Agosto</th>
        <th scope="col">Settembre</th>
        <th scope="col">Ottobre</th>
        <th scope="col">Novembre</th>
        <th scope="col">Dicembre</th>
        <th scope="col">Totale</th>
      </tr>
      </thead>
      <tbody >
      <tr *ngFor="let item of Reports ">
        <td class="align-middle" >
          <span>
            {{ item.cliente }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['1'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['2'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['3'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['4'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['5'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['6'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['7'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['8'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['9'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['10'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['11'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['12'] }}
          </span>
        </td>
        <td class="align-middle" >
          <span>
            {{ item['tot'] }}
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</div>
<aside class="customizer"  >
  <div style="position: fixed; bottom: 20px; right: 10px;">
    <div class="d-md-flex align-items-center justify-content-end">
      <button type="submit" (click)="StampaSelezionati()" class=" btn btn-rounded btn-success p-2 waves-effect waves-light">
        <span class="ml-1 text-white font-weight-bold"> Stampa </span>
        <i-feather name="printer" class="feather-sm "></i-feather>
      </button>
    </div>
  </div>
</aside>

